export default "__VITE_ASSET__DvC6MPju__"